import firebase from "firebase";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD7B6N8p-_cveUNkWJRCt5akqVRcw8j1Wo",
  authDomain: "zoominsight-37d0c.firebaseapp.com",
  databaseURL: "https://zoominsight-37d0c-default-rtdb.firebaseio.com",
  projectId: "zoominsight-37d0c",
  storageBucket: "zoominsight-37d0c.appspot.com",
  messagingSenderId: "586576638359",
  appId: "1:586576638359:web:2e767d42a806e9407114d2",
  measurementId: "G-VE08XB2E0B",
};
// Initialize Firebase
export const app = firebase.initializeApp(firebaseConfig);
//firebase.analytics();

//export default firebase; 